import React, { useState } from "react";
import { AiOutlineEye } from "react-icons/ai";
import CustomModal from "../../../components/main_comps/custom_modal";
import { getFileExtension } from "../clients/client_details/ClientsDocument";

const Container = ({ title, value, onClick, url }) => {
  return (
    <div
      style={{
        marginBottom: "20px",
      }}
    >
      <label
        style={{
          color: "#6C6B6B",
          fontSize: "12px",
          fontWeight: "500",
        }}
      >
        {title}
      </label>
      <div
        style={{
          width: "40%",
          maxWidth: "400px",
          minWidth: "300px",
          backgroundColor: "rgba(111, 108, 255, 0.05)",
          height: "55px",
          display: "flex",
          padding: "0px 15px",
          boxSizing: "border-box",
          justifyContent: "space-between",
          alignItems: "center",
          borderRadius: 5,
          cursor: "pointer",
        }}
        onClick={() => onClick(url, title)}
      >
        <p style={{ color: "#38369C" }}>{title}</p>
        <AiOutlineEye color="#38369C" size="20" />
      </div>
    </div>
  );
};

const ResellerDocument = ({ data }) => {
  const [openModal, setOpenModal] = useState(false);
  const [url, seturl] = useState("");
  const [fiieName, setfiieName] = useState("");

  return (
    <div style={{ padding: "10px 20px" }}>
      <Container
        title="Pan card"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.panCardUrl}
      />
      <Container
        title="Gst Certificate"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.gstCertificateUrl}
      />
      <Container
        title="Incorporation Certifcate"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.incorporationCertificateUrl}
      />
      <Container
        title="Signed SLA"
        onClick={(data, file) => {
          setOpenModal(true);
          seturl(data);
          setfiieName(file);
        }}
        url={data?.uploadSignedSlaUrl}
      />
      {openModal && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
            maxWidth: 400,
          }}
          open={openModal}
          isBackRequired={false}
          headerTitle={fiieName}
          onClose={() => {
            setOpenModal(false);
          }}
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            {getFileExtension(url) === "pdf" ? (
              <>
                <iframe
                  src={url}
                  sandbox="allow-downloads"
                  frameborder="0"
                  height="500px"
                  width="100%"
                ></iframe>
              </>
            ) : (
              <img
                src={url}
                sandbox="allow-downloads"
                style={{
                  borderRadius: "20px",
                  width: "100%",
                  height: "80%",
                  marginTop: "10px",
                }}
                alt="Documents"
              />
            )}
          </div>
        </CustomModal>
      )}
    </div>
  );
};

export default ResellerDocument;
